import { AxiosError } from 'axios';
import { all, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { createRequestTypes, FETCH_RECEIPTS_CSV_REPORT_V2, FETCH_RECEIPTS_V2 } from '~/actions';
import { apiMethodsConst } from '~/services/methods';
import { callAndDispatch } from './utils';
import { ReceiptUtils } from '~/utils/ReceiptUtils';

export function* watchFetchReceiptsV2() {
  const events: any = createRequestTypes(FETCH_RECEIPTS_V2);

  function* handler({ payload }: any) {
    yield put({
      type: events.REQUEST,
      payload,
    });

    try {
      yield* callAndDispatch(apiMethodsConst.FETCH_RECEIPTS_V2_REQUEST, {
        ...payload,
        ...ReceiptUtils.getTransactionDates(payload.transactionDate),
      });

      yield put({ type: events.SUCCESS });
    } catch (e) {
      yield put({ type: events.FAILURE, error: (e as AxiosError)?.response?.data });
    }
  }

  // Every request supersedes the one in flight — a next page waits on the last one
  // to settle, so only a new office set, sort or date range can overlap it — and a
  // superseded response would replace the newer rows (GOTU-19472).
  yield takeLatest(FETCH_RECEIPTS_V2, handler);
}

function* watchFetchReceiptsCSVReportV2() {
  const events: any = createRequestTypes(FETCH_RECEIPTS_CSV_REPORT_V2);

  function* handler({ payload }: any) {
    yield put({ type: events.REQUEST });

    try {
      yield* callAndDispatch(apiMethodsConst.FETCH_RECEIPTS_CSV_REPORT_V2_REQUEST, {
        ...payload,
        ...ReceiptUtils.getTransactionDates(payload.transactionDate),
      });

      yield put({ type: events.SUCCESS });
    } catch (e) {
      yield put({ type: events.FAILURE, error: (e as AxiosError)?.response?.data });
    }
  }

  yield takeEvery(FETCH_RECEIPTS_CSV_REPORT_V2, handler);
}

export default function* sagaReceipts() {
  yield all([fork(watchFetchReceiptsV2), fork(watchFetchReceiptsCSVReportV2)]);
}
